import Component from '@glimmer/component';
import { action } from '@ember/object';
import { later } from '@ember/runloop';
import { tracked } from '@glimmer/tracking';
import { countriesData } from './countries-data';
import { phoneNumberRegex } from 'mewe/shared/utils';

export default class MwPhoneInput extends Component {
  countryItems = countriesData;

  @tracked selectedCountry;
  @tracked phoneNumber;
  @tracked searchValue = '';
  @tracked searchedItems = [];

  constructor() {
    super(...arguments);

    if (this.args.initialCountry) {
      const initialCountry = Number(this.args.initialCountry.replace('+', ''));
      this.selectedCountry = this.countryItems.find(country => country.dialCode === initialCountry);
    } else {
      this.selectedCountry = this.countryItems[0];
    }

    if (this.args.initialPhone) {
      this.phoneNumber = this.args.initialPhone;
    } else {
      this.phoneNumber = '';
    }
  }

  get countryItemsOrSearchResults() {
    return this.searchValue.length > 0 ? this.searchedItems : this.countryItems;
  }

  @action
  onInsert(element) {
    const input = element.querySelector('input');
    if (input) {
      input.classList.add('h-input_text');

      // (SG-39785) - country code is not detected properly if user pastes/autocompletes the phone number
      // but triggering additional update of the number fixes the issue
      const triggerUpdate = () => {
        const inputEvent = new Event('input', {
          bubbles: true,
          cancelable: true,
        });

        later(this, () => input.dispatchEvent(inputEvent), 10);
      };

      input.addEventListener('paste', triggerUpdate);
      input.addEventListener('change', triggerUpdate);
    }
  }

  @action
  selectCountry(country) {
    this.selectedCountry = country;
    this.searchValue = '';
    this.phoneUpdated();
  }

  @action
  phoneUpdated() {
    let number = this.phoneNumber;
    let code = this.selectedCountry.dialCode;
    let isValidNumber = phoneNumberRegex.test('+' + code + number);

    // hack for testers to be able to use +89 as a country code
    if (number.slice(0, 3) === '+89') {
      code = '89';
      number = number.slice(3);
      isValidNumber = true;
    }

    this.args.updatePhone({ number, code, isValidNumber });
  }

  @action
  setSearchValue(value) {
    this.searchValue = value;
  }

  @action
  setSearchedItems(items) {
    this.searchedItems = items;
  }
}
